export default __webpack_public_path__ + "4cf222256f7dc54f1c76ae70398d426c.png";